<template>
  <!-- 数据管理 - 清单数据库 author: zhangxiaofeng-->
  <div class="wrap data-management inventory_main" ref="scrollBody" id="scrollBody">
    <div class="content--options" id="contentOptions">
      <operation-select-major @change="majorChangeFn"
                              :refresh-region-list="refreshRegionList"
                              @operateMoreMajor="calcTableHeight"
                              parentRegion="inventory"
      >
      </operation-select-major>
      <div class="list" :style="{'height': isFixed ? '91px' : ''}">
        <div :class="{'fixed': isFixed, 'fold-menu' : foldMenu}">
          <!-- 按钮组 -->
          <operation-buttons :button-list="buttonList"
                             @clickHandle="topButtonClick"
                             origin="database"
                             @uploadHandle="upload"
                             type="inventory"
                             :disabled-button="disabledButton"
                             :tip-content="tipContent"
                             class="float_left">
          </operation-buttons>

          <!-- 高级搜索 -->
          <dialog-senior-search :key="refreshRegionList"
                                class="float_right"
                                page="inventory"
                                @onSearch="seniorSearchHandle">
          </dialog-senior-search>

          <!-- 搜索 -->
          <operation-search :key="refreshRegionList" placeholder="请输入名称或项目特征" class="float_right"
                            @onSearch="searchHandle">
          </operation-search>
        </div>
      </div>
    </div>

    <div class="tree-table fit flex flex-column table-medium table-beyond-hiding" :style="{height: tableHeight + 'px'}" id="tree-table">
      <div class="header-wrapper" ref="headerWrapper">
        <div class="table-header flex flex-row" :style="{width: (scrollY ? (tableWidth + 17) : tableWidth) + 'px'}">
          <div class="header-item is-leaf is-center" style="width: 40px;">
            <label>
              <!-- 表头那个全选 下拉框 -->
              <select-all :pageTotal="Math.ceil(page.total / page.size)"
                          :current-page-item-count="dataList.length / 2"
                          :current-page-item-selected="selectList.length"
                          @change="selectAllChange"
                          :reset-select-all="resetSelectAll"
                          :top="31" :left="0">
              </select-all>
            </label>
          </div>
          <div class="header-item is-leaf is-left" style="width: 100px;">编码</div>
          <div class="header-item is-leaf is-left" style="width: 200px;">名称</div>
          <div class="header-item is-leaf is-left flex-1">项目特征</div>
          <div class="header-item is-leaf is-center" style="width: 40px;">单位</div>
          <template v-if="pageType === 'databaseBasis'">
            <div class="header-item is-leaf is-center" style="width: 120px;">上传人</div>
          </template>
          <div class="header-item is-leaf is-center" style="width: 80px;">
            <em class="sort-btn-fixed position-relative cursor-pointer" @click="changeSort('time')">
              上传时间
              <i :class="currentSort.time === 0 ? 'sort-up' : currentSort.time === 1 ? 'sort-down' : 'sort'"></i>
            </em>
          </div>
          <template v-if="pageType === 'databaseBasis'">
            <div class="header-item is-leaf is-center" style="width: 100px;">数据来源</div>
            <div class="header-item is-leaf is-center" style="width: 100px;">审核人</div>
            <div class="header-item is-leaf is-center" style="width: 120px;">
              <em class="sort-btn-fixed position-relative cursor-pointer" @click="changeSort('inspected')">
                审核状态
                <i
                  :class="currentSort.inspected === 0 ? 'sort-up' : currentSort.inspected === 1 ? 'sort-down' : 'sort'"></i>
              </em>
            </div>
          </template>
          <div class="header-item is-leaf is-center" style="width: 100px;"></div>
          <div class="has-gutter" v-if="scrollY"></div>
        </div>
      </div>
      <div class="body-wrapper flex-1" style="overflow: auto;" ref="bodyWrapper">
        <ul class="container" :style="{width: tableWidth + 'px'}" ref="containerWrapper">
          <template v-for="(item, idx) in dataList">
            <collapse>
              <li class="flex flex-row row row--level-1 collapse" :key="'tr_' + idx" v-show="item.show">
                <p class="data1-p background-white margin-top-10 width-full">
                  一、工作内容
                  <br>
                  <template v-for="(cont, index) in item.content">
                    {{index + 1}}.{{cont.Description}}
                    <br :key="index">
                  </template>
                  二、计算规则
                  <br>
                  {{item.rule}}
                </p>
              </li>
            </collapse>
            <li class="flex flex-row row row--level-1" v-if="!item.parentId">
              <div class="cell column_1 is-left" style="width: 40px;">
                <label class="w__checkbox" style="margin-right: 0;" :class="{'is-checked': item.checked}">
                  <span aria-checked="mixed" class="w__checkbox__input" :class="{'is-checked': item.checked}">
                    <span class="w__checkbox__inner" @click.stop="dealItem('check', item, idx)"></span>
                    <input type="checkbox" aria-hidden="true" class="w__checkbox__original" value="">
                  </span>
                </label>
              </div>
              <div class="cell column_2 is-left" style="width: 100px;">
                <div class="inline-block icon" style="margin-left: 0px;">
                  <a :class="['view-more', item.childShow ? 'close' : '']" @click="dealItem('fold', item, idx)"></a>
                </div>
                {{item.addicode}}{{item.code}}
              </div>
              <div class="cell column_3 is-left" style="width: 200px;">{{item.description}}</div>
              <div class="cell column_4 is-left flex-1">{{item.spec}}</div>
              <div class="cell column_5 is-center" style="width: 40px;">{{item.unit}}</div>
              <template v-if="pageType === 'databaseBasis'">
                <div class="cell column_6 is-center" style="width: 120px;">{{item.authorIdStr}}</div>
              </template>
              <div class="cell column_7 is-center" style="width: 80px;">{{item.createtimestr}}</div>
              <template v-if="pageType === 'databaseBasis'">
                <div class="cell column_8 is-center" style="width: 100px;">{{item.source}}</div>
                <div class="cell column_9 is-center" style="width: 100px;"><span>{{!item.inspector && +item.inspected > 0 ? '无需审核' : item.inspector}}</span>
                </div>
                <div class="cell column_10 is-center" style="width: 120px;">
                  <span>
                    <template v-if="+item.inspected === 0">
                      <span :class="['action-accept', item.professionAllowed ? '' : 'invalid']"
                            @click="dealItem('inspect', item, idx, true)">通过</span>
                      <span :class="['action-reject', item.professionAllowed ? '' : 'invalid']"
                            @click="dealItem('inspect', item, idx, false)">不通过</span>
                    </template>
                    <span class="inspect-status accept" v-else-if="+item.inspected === 1">审核通过</span>
                    <span class="inspect-status reject" v-else-if="+item.inspected === 2">审核未通过</span>
                  </span>
                </div>
              </template>
              <div class="cell column_11 is-center" style="width: 100px;">
                <el-tooltip content="修改">
                  <i class="w-icon-xiugai cursor-pointer margin-right-10" :class="[item.professionAllowed ? '' : 'invalid']"
                     @click="dealItem('edit', item, idx)"></i>
                </el-tooltip>
                <el-tooltip content="删除">
                  <i class="r2-icon-action_delete_outline cursor-pointer margin-right-10" :class="[item.professionAllowed ? '' : 'invalid']"
                     @click="dealItem('delete', item, idx)"></i>
                </el-tooltip>
                <el-tooltip content="移动到">
                  <i class="w-icon-yidong cursor-pointer" :class="[item.professionAllowed ? '' : 'invalid']"
                     @click="dealItem('move', item, idx)"></i>
                </el-tooltip>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>

    <!-- 表头那个全选 下拉框  th-normal -->
    <simple-table :isHeight='false' v-if="false"
                  :showNoData="dataList.length === 0"
                  :is-empty="dataList.length < 1"
                  :is-scroll="false">
      <template slot="headTable">
        <div :class="['table-head-wrapper', isFixed ? 'th-fixed' : '', foldMenu ? 'fold-menu' : '']">
          <table cellspacing="0" cellpadding="0" border="0" class="table-head">
            <thead class="has-gutter">
            <tr>
              <th width="40" class="font-left">
                <label class="checkbox-label th">
                  <!-- 表头那个全选 下拉框 -->
                  <select-all :pageTotal="Math.ceil(page.total / page.size)"
                              :current-page-item-count="dataList.length / 2"
                              :current-page-item-selected="selectList.length"
                              @change="selectAllChange"
                              :reset-select-all="resetSelectAll"
                              :top="31" :left="-6">
                  </select-all>
                </label>
              </th>
              <th width="10" class="font-center"></th>
              <th class="font-left" width="100">编码</th>
              <th class="font-left" width="200">名称</th>
              <th class="font-left">项目特征</th>
              <th class="font-center" width="40">单位</th>
              <template v-if="pageType === 'databaseBasis'">
                <th class="font-left" width="120">上传人</th>
              </template>
              <th class="font-center" width="80">
                <em class="sort-btn-fixed position-relative cursor-pointer" @click="changeSort('time')">
                  上传时间
                  <i :class="currentSort.time === 0 ? 'sort-up' : currentSort.time === 1 ? 'sort-down' : 'sort'"></i>
                </em>
              </th>
              <!-- R2  第二迭代 去掉地区列 -->
              <!--
              <th class="font-center" width="40">地区</th>
              -->
              <template v-if="pageType === 'databaseBasis'">
                <th class="font-left" width="100">数据来源</th>
                <th class="font-left" width="100">审核人</th>
                <!-- 审核状态 -->
                <th class="font-left" width="120">
                  <em class="sort-btn-fixed position-relative cursor-pointer" @click="changeSort('inspected')">
                    审核状态
                    <i
                      :class="currentSort.inspected === 0 ? 'sort-up' : currentSort.inspected === 1 ? 'sort-down' : 'sort'"></i>
                  </em>
                </th>
              </template>
              <!-- 操作 -->
              <th class="font-center" width="100"></th>
            </tr>
            </thead>
          </table>
        </div>
      </template>
      <template slot="body" v-if='dataList.length>0'>
        <tbody id="projectContent">
        <template v-for="(item, idx) in dataList">
          <tr class="nohoverclass" v-if="item.parentId" :key="'tr_' + idx" v-show="item.show">
            <td :colspan="item.colspan">
              <p class="data1-p">
                一、工作内容
                <br>
                <template v-for="(cont, index) in item.content">
                  {{index + 1}}.{{cont.Description}}
                  <br :key="index">
                </template>
                二、计算规则
                <br>
                {{item.rule}}
              </p>
            </td>
          </tr>
          <tr v-else :key="'tr_' + idx">
            <td width="40" class="font-left">
              <label class="w__checkbox" style="margin-right: 0;" :class="{'is-checked': item.checked}">
                  <span aria-checked="mixed" class="w__checkbox__input" :class="{'is-checked': item.checked}">
                    <span class="w__checkbox__inner" @click.stop="dealItem('check', item, idx)"></span>
                    <input type="checkbox" aria-hidden="true" class="w__checkbox__original" value="">
                  </span>
              </label>
              <!--<input class="checkbox-label" type="checkbox" :checked="item.checked" @click="dealItem('check', item, idx)">-->
            </td>
            <td width="10" class="font-center">
              <a :class="['view-more', item.childShow ? 'close' : '']" @click="dealItem('fold', item, idx)"></a>
            </td>
            <td width="100" class="break-word-wrap">{{item.addicode}}{{item.code}}</td>
            <td width="200" class="font-left">{{item.description}}</td>
            <td class="font-left break-word-wrap">{{item.spec}}</td>
            <td width="40" class="font-center">{{item.unit}}</td>
            <template v-if="pageType === 'databaseBasis'">
              <td width="120" class="font-left break-word-wrap">{{item.authorIdStr}}</td>
            </template>

            <td width="80" class="font-center">{{item.createtimestr}}</td>

            <!-- R2  第二迭代 去掉地区列 -->
            <!--
              <td width="40" class="font-center">{{item.region}}</td>
             -->
            <template v-if="pageType === 'databaseBasis'">
              <td class="font-left" width="100">{{item.source}}</td>
              <td class="font-left" width="100">
                {{!item.inspector && +item.inspected > 0 ? '无需审核' : item.inspector}}
              </td>
              <!-- 审核状态 -->
              <td class="font-left" width="120">
                <div class="action-inspect" v-if="+item.inspected === 0">
                    <span :class="['action-accept', item.professionAllowed ? '' : 'invalid']"
                          @click="dealItem('inspect', item, idx, true)">通过</span>
                  <span :class="['action-reject', item.professionAllowed ? '' : 'invalid']"
                        @click="dealItem('inspect', item, idx, false)">不通过</span>
                </div>
                <span class="inspect-status accept" v-else-if="+item.inspected === 1">
                    审核通过
                  </span>
                <span class="inspect-status reject" v-else-if="+item.inspected === 2">
                    审核未通过
                  </span>
              </td>
            </template>

            <td width="100" class="font-right operation">
              <el-tooltip content="修改">
                <i :class="['w-icon-xiugai', item.professionAllowed ? '' : 'invalid']"
                   @click="dealItem('edit', item, idx)"></i>
              </el-tooltip>
              <el-tooltip content="删除">
                <i :class="['r2-icon-action_delete_outline', item.professionAllowed ? '' : 'invalid']"
                   @click="dealItem('delete', item, idx)"></i>
              </el-tooltip>
              <el-tooltip content="移动到">
                <i :class="['w-icon-yidong', item.professionAllowed ? '' : 'invalid']"
                   @click="dealItem('move', item, idx)"></i>
              </el-tooltip>
            </td>
          </tr>
        </template>
        </tbody>
      </template>
      <!--<div slot="body" v-else class="empty-box cursor-pointer" @click = "openHelp">-->
      <!--<img src="@/assets/images/default_empty.png">-->
      <!--<p>点击这里上传您的第一条清单数据</p>-->
      <!--</div>-->
      <template slot="no-data">
        <a href="/doc/guide_list.html" target="_blank">点击这里</a>
        上传您的第一条清单数据
      </template>
    </simple-table>
    <!-- 分页区域 -->

    <div class="page-box" v-if="page.total> 0">
      <w-pagination
        @current-change="changePageCurrent"
        @size-change="changePageSize"
        :current-page.sync="page.current"
        background
        layout="total, prev, pager, next, jumper, sizes"
        :page-size="page.size"
        :page-sizes="[50, 100, 150, 200]"
        :total="page.total">
      </w-pagination>
    </div>

    <!-- 移动到 弹窗 -->
    <dialog-move-to :show="dialog.moveTo.show"
                    @submit="moveToSubmit"
                    @cancel="moveToCancel"
                    :edit-data="dialog.moveTo.data">
    </dialog-move-to>

    <!-- 修改清单 弹窗 -->
    <dialog-edit-inventory :show="dialog.inventory.show"
                           :edit-data="dialog.inventory.data"
                           @submit="editSubmit"
                           @cancel="editCancel">
    </dialog-edit-inventory>


    <!-- 结果 -->
    <w-dialog @close="dialog.copyResult.show = false" :show="dialog.copyResult.show">
      <span class="w__dialog--title" slot="header">复制结果</span>
      <p>{{dialog.copyResult.text}}</p>
      <div v-if="dialog.copyResult.error">
        <br>
        <p> 未导入原因： </p>
        <p id="upload_result1">
          1、企业空间已存在相同数据
        </p>
      </div>
      <div slot="footer">
        <!--<input-->
        <!--class="ui-btn ui-btn_blue"-->
        <!--type="button"-->
        <!--value="查看详情"-->
        <!--v-if="dialog.copyResult.error"-->
        <!--@click="showDetail"/>-->
        <!--<input class="ui-btn" type="button" value="关闭" @click="dialog.copyResult.show = false" />-->
        <w-button type="primary" @click.stop.prevent="showDetail" v-if="dialog.copyResult.error">查看详情
        </w-button>
        <w-button type="minor" @click.stop.prevent="dialog.copyResult.show = false">关闭</w-button>
      </div>
    </w-dialog>

    <!-- 上传云文件 -->
    <UploadCloudFiles v-if="UploadCloudFilesShow" @affirm="UploadCloudFilesAffirm" @cancle="UploadCloudFilesCancle"/>
    <!-- 返回顶部 -->
    <w-backtotop
      scroll-el="scrollBody"
      transition-name="bottomToTop"
      hover-text="返回顶部"
      hover-class="hover-class"
      :back-position="0"
      :visibility-height="110"
      icon-name="w-icon-xiala-copy icon-demo"
      custom-class="demo-3-class"
    ></w-backtotop>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {
  OperationSelectMajor,
  DialogSeniorSearch,
  OperationButtons,
  OperationSearch,
  SelectAll,
  Collapse,
  DialogMoveTo,
  SimpleTable,
  DialogEditInventory
} from '@/components/common'
import UploadCloudFiles from '_c/common/UploadCloudFiles/Index.vue'
import service from '@/assets/service'
import {getCookie} from '@/assets/utils/CommonUtil'
import {on, off} from '@/assets/utils'
import {throttle} from 'throttle-debounce'
import Bus from '@/assets/utils/bus'
import uploadMixin from '@/assets/mixins/upload'
import databaseBasisMixin from '@/assets/mixins/database-basis'

const buttonList = ['upload', 'export', 'copyToCompanySpace', 'move', 'inspectBatch', 'delete']
export default {
  name: 'DatabaseInventory',
  mixins: [uploadMixin, databaseBasisMixin],
  data () {
    return {
      tableWidth: 0,
      scrollY: false,
      isFixed: false,
      refreshRegionList: 0, // 刷新时 重新获取地区列表
      buttonList,
      dialog: { // 弹窗
        moveTo: { // 移动到
          show: false,
          data: {}
        },
        inventory: { // 修改清单
          show: false,
          data: {}
        },
        copyResult: { // 复制结果弹窗
          show: false,
          error: null,
          text: ''
        }
      },
      page: {
        total: 0,
        current: 1,
        size: 50
      },
      currentSort: {
        time: '', // 当前时间排序
        inspected: '' // 当前审核状态排序
      },
      // 获取清单列表 传递的参数
      queryParams: {
        region: '', // 地区
        profession: '', // 专业
        descOrSpec: '', // 名称或项目特征
        code: '', // 编码
        authorId: '', // 上传人
        inspected: '' // 审核状态
      },
      selectPage: '', // 全选下拉框 已选中的值 current: 当前页、all: 所有页
      resetSelectAll: 0,
      selectList: [], // 已选择 清单 id列表
      selectedObj: {},
      unSelectObj: {}, // 未选择 清单 id列表
      dataList: [],
      UploadCloudFilesShow: false, // 显示上传云文件 弹窗
      scrollEvent: null,
      user: {}
    }
  },
  computed: {
    ...mapState({
      foldMenu: state => state.menus.foldMenu // 是否折叠菜单
    })
  },
  watch: {
    foldMenu (newVal, oldVal) {
      if (newVal !== oldVal) {
        setTimeout(() => {
          this.calcTableHeight()
        }, 500)
      }
    }
  },
  beforeDestroy () {
    this.initEvent()
    off(this.$refs.bodyWrapper, 'scroll', this.handleScroll)
  },
  mounted () {
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    Bus.$on('uploadOne', (file) => {
      this.topButtonClick('refresh')
    })
    // Bus.$on('uploadAll', (file) => {
    //   this.topButtonClick('refresh');
    // });
    Bus.$on('closeUploadCloudFile', () => {
      this.UploadCloudFilesShow = false
    })
    this.initEvent(true)
    let otherHeight = 45 + 55 + 52 + 50
    this.setTableHeight(otherHeight)
    this.calcTableHeight()
    // 窗口大小改变时 触发
    this.resizeHandle.resize(() => {
      this.setTableHeight(otherHeight)
      this.calcTableHeight()
    })
    on(this.$refs.bodyWrapper, 'scroll', this.handleScroll)
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
  },
  methods: {
    calcTableHeight () {
      let tableWidth = 720
      if (this.pageType === 'databaseBasis') {
        tableWidth += 440
      }
      if (tableWidth < this.getDomWidth('scrollBody') - 20) {
        tableWidth = this.getDomWidth('scrollBody') - 20
      }
      if (this.scrollY) {
        tableWidth -= 17
      }
      this.tableWidth = tableWidth
      this.tableHeight = this.getTableHeight('scrollBody') - this.getTableHeight('contentOptions') - 30
    },
    // 滚动条滚动事件
    handleScroll (event) {
      this.$refs.headerWrapper.scrollLeft = this.$refs.bodyWrapper.scrollLeft
    },
    // . 初始化页面滚动事件
    initEvent (init) {
      const scrollBody = this.$refs.scrollBody
      if (!scrollBody) return
      if (this.scrollEvent) {
        off(scrollBody, 'scroll')
        this.scrollEvent = null
      }
      if (init) {
        on(scrollBody, 'scroll', this.scrollEvent = throttle(10, () => {
          if (document.getElementsByClassName('list')[0].getBoundingClientRect().top < 56) {
            this.isFixed = true
          } else {
            this.isFixed = false
          }
        }))
      }
    },
    // 1. 修改专业、切换地区时 触发
    majorChangeFn (obj) {
      this.calcTableHeight()
      // console.log('888888888888')
      // console.log(obj)
      this.clearSeniorSearch()
      switch (obj.changeType) {
        case 'region':
          // 选定的地区记录到浏览器里
          sessionStorage.setItem('inventory_' + this.user.gldUserId, obj.region)
          this.queryParams.region = obj.region
          this.queryParams.profession = obj.major // 专业
          break
        default:
      }
      this.getInventoryList('region')
    },
    // 2. 搜索
    searchHandle (name) {
      // console.log('搜索: ' + name)
      this.clearSeniorSearch()
      this.queryParams.descOrSpec = name
      this.getInventoryList('search')
    },
    // 2.1 高级搜索
    seniorSearchHandle (obj) {
      // console.log('高级搜索: ' + JSON.stringify(obj))
      for (const key in obj) {
        this.$set(this.queryParams, key, obj[key])
      }
      this.getInventoryList('seniorSearch')
    },
    // 2.2 清空高级搜索 的条件
    clearSeniorSearch () {
      this.queryParams.code = ''
      this.queryParams.authorId = ''
      this.queryParams.inspected = ''
      this.queryParams.descOrSpec = ''
    },
    // 3.1 上传
    upload (files, e, type) {
      // console.log('------------')
      switch (type) {
        case 'CloudFile': // 上传云文件
          this.UploadCloudFilesShow = true
          break
        case 'LocalFile': // 上传本地文件 "ImportType": 1 // 导入清单是否需要把其组价方案一起导入？ 否 3: 是
          Bus.$emit('openUploader', {
            parameter: {
              uploadType: 2,
              params: JSON.stringify({
                'IsOffline': false,
                'SourceType': 4,
                'ImportType': 1,
                'userType': this.user.userType
              }),
              spaceType: this.pageType === 'databaseBasis' ? 2 : 1
            },
            uploadAction: 'data_manage/bill_quantity/upload_local_file'
          })
          break
        case 'PlatformFile': // 上传平台接口
          Bus.$emit('openUploader', {
            parameter: {
              uploadType: 3,
              params: JSON.stringify({
                'IsOffline': false,
                'SourceType': 3,
                'ImportType': 1,
                'userType': this.user.userType
              }),
              spaceType: this.pageType === 'databaseBasis' ? 2 : 1
            },
            uploadAction: 'data_manage/bill_quantity/upload_platform_file'
          })
          break
        default:
          // 普通的上传
          console.log('上传')
          console.log(files)
          console.log(e)

      }
    },
    // 3.2 顶部其他按钮点击
    topButtonClick (type, e) {
      // console.log(type)
      // console.log(e)
      switch (type) {
        case 'export':
        case 'copyToCompanySpace':
        case 'delete':
        case 'move':
        case 'inspectBatch':
          this.dealItem(type)
          break
        case 'refresh':
          this.refreshRegionList++
          this.getInventoryList('refresh')
          break
        default:
      }
    },
    // 4. 全选下拉框 切换时
    selectAllChange (type, value) {
      this.selectPage = type
      if (!value && this.selectPage === 'all') {
        this.selectPage = ''
      }
      this.unSelectObj = {}
      this.dataList.forEach((item, idx) => {
        if (item.bqitemid) {
          this.dealItem('check', item, idx, value)
        }
      })
    },
    // 4.1 发送请求前 清除数据
    clearData (changeType) {
      switch (changeType) {
        case 'page':
        case 'pageSize':
        case 'sort':
          if (this.selectPage !== 'all') {
            this.resetSelectAll++
          }
          break
        default:
          this.page.current = 1
          this.selectedObj = {}
          this.selectList = []
          this.unSelectObj = {}
          this.selectPage = ''
          this.currentSort.time = ''
          this.currentSort.inspected = ''
          this.resetSelectAll++
      }
    },
    // 5. 获取清单列表
    getInventoryList (changeType) {
      this.loading = true
      this.clearData(changeType)
      const params = {
        pageNo: this.page.current,
        pageSize: this.page.size
      }
      service.inventory.getInventoryList(Object.assign(params, this.queryParams)).then((data) => {
        this.dataList = []
        if (+data.code === 200 && data.data) {
          this.page.total = data.data.total || 0
          // 列表数据增加权限校验
          const inventoryList = this.verifyPermission(data.data.items)
          const len = inventoryList.length
          const children = []
          inventoryList.forEach((item, idx) => {
            children[idx] = {
              parentId: item.bqitemid,
              show: false,
              colspan: this.pageType === 'databaseBasis' ? 12 : 8, // 合并几个单元格
              content: (item.bqSlaveWorkScope && JSON.parse(item.bqSlaveWorkScope)) || [], // 工作内容
              rule: item.quantitycalcrule || '' // 计算规则
            }
          })
          const showList = []
          for (let i = 0; i < len; i++) {
            let checked = this.selectPage === 'all'
            if (this.unSelectObj[inventoryList[i].bqitemid]) {
              checked = false
            }
            // showList.push(Object.assign(inventoryList[i], {childShow: false, checked, children: [children[i]], showExpand: false, showChildren: false}))
            showList.push(Object.assign(inventoryList[i], {childShow: false, checked}))
            showList.push(children[i])
          }
          this.dataList = showList
          // console.log(JSON.parse(inventoryList[0].bqSlaveWorkScope)) // 工作内容
          // console.log(inventoryList[0].quantitycalcrule) // 计算规则
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 5.1 切换页码
    changePageCurrent (current) {
      this.page.current = current
      this.getInventoryList('page')
    },
    // 5.2 切换 每一页显示条数
    changePageSize (size) {
      this.page.current = 1
      this.page.size = size
      this.getInventoryList('pageSize')
    },
    // 5.3 修改排序时
    changeSort (type) {
      if (this.currentSort[type] === '') {
        this.currentSort[type] = 0
      } else {
        this.currentSort[type] = (this.currentSort[type] + 1) % 2
      }
      this.$set(this.queryParams, [type] + 'Sort', this.currentSort[type])
      this.page.current = 1
      this.getInventoryList('sort')
    },
    // 6. 操作清单数据
    dealItem (type, item, idx, value) {
      if (item) {
        if (['inspect', 'edit', 'delete', 'move'].includes(type) && !item.professionAllowed) {
          // 单条操作 时 无权限 则直接返回
          return
        }
        this.operationBatch = false
      } else {
        if (type === 'export' && this.pageType === 'databaseBasis' && this.role !== 2) {
          // 总负责人 才能导出 电子档案室的数据
          return
        }
        this.operationBatch = true
      }
      let selectCount = 0
      let params = {}
      params.modelType = '_bqItem'
      if (item) {
        selectCount = 1
        params.bqItemId = item.bqitemid // 清单id
        params.profession = item.professionGuid // 专业id
        params.selectAllPages = false
      } else {
        // 批量操作
        params.selectAllPages = this.selectPage === 'all'
        if (this.selectPage === 'all' && this.dataList.length) {
          // 批量操作 所有页面时 未选择项 id 需传递给后台
          // console.log(this.unSelectObj)
          // console.log('===========')
          const unSelectedIdArr = []
          for (const key in this.unSelectObj) {
            unSelectedIdArr.push(key)
          }
          selectCount = this.page.total - unSelectedIdArr.length
          params.unSelectedIds = unSelectedIdArr.join(',')
          params.bqItemId = '' // 清单id
        } else {
          // 批量操作 当前页时
          // console.log(this.selectList)
          selectCount = this.selectList.length
          params.bqItemId = this.selectList.join(',') // 清单id
        }
      }
      const operations = {
        edit: '修改',
        inspect: '审核',
        inspectBatch: '审核',
        delete: '删除',
        move: '移动',
        copyToCompanySpace: '复制',
        export: '导出'
      }
      if (!selectCount) {
        let msg = ''
        switch (type) {
          case 'export':
            msg = '请勾选要导出的清单数据'
            break
          default:
            msg = '请选择需要' + operations[type] + '的清单列表'
        }
        this.$message.info({message: msg})
        return
      }
      params = Object.assign({}, this.queryParams, params)
      let num = params.bqItemId.split(',').length
      if (params.selectAllPages) {
        num = this.page.total - params.unSelectedIds.split(',').length
      }
      params.num = num
      // console.log(item)
      console.log(params)
      switch (type) {
        case 'inspect': // 审核 单条数据
          params.inspection = value || false
          this.loading = true
          service.inventory.inspect(params).then((data) => {
            if (+data.code === 200) {
              this.getInventoryList()
            } else {
              // +data.code === 290004 无权限操作数据时 操作失败
              this.$message.error('操作失败')
              this.loading = false
            }
          })
          break
        case 'inspectBatch': // 批量审核（审核通过）
          this.loading = true
          service.inventory.inspectBatch({inspection: true}, params).then(res => {
            if (+res.code === 200) {
              // console.log(res)
            } else {
              // +data.code === 290004 无权限操作数据时 操作失败
              // this.$message.error('操作失败')
            }
            this.getInventoryList()
          })
          break
        case 'export': // 导出
          this.$confirm({
            message: '确定导出勾选的清单数据？',
            dealData: params,
            submit: (data) => {
              this.exportConfirm(data)
            }
          })
          break
        case 'delete': // 删除
          let msg = '确定删除勾选的清单数据？'
          if (this.selectPage === 'all') {
            msg = `确定删除所有页（共${Math.ceil(this.page.total / this.page.size)}页）数据？`
          }
          this.$confirm({
            message: item ? '确定删除？' : msg,
            type: 'warning',
            tips: '删除后，数据将不可恢复',
            width: 370,
            dealData: params,
            submit: (data) => {
              this.deleteConfirm(data)
            },
            cancel: () => {
            },
            submitText: '确定删除'
          })
          break
        case 'copyToCompanySpace': // 复制到电子档案室
          this.$confirm({
            message: '确定要将勾选的清单数据复制到电子档案室？',
            dealData: params,
            submit: (data) => {
              this.copyConfirm(data)
            },
            submitText: '确定复制'
          })
          break
        case 'check': // 选择行
          let checked = item.checked
          if (value !== undefined) {
            checked = !value
          }
          // console.log(item)
          // 把 取消选择的项 放到 未选择列表中;
          if (this.selectPage === 'all') {
            if (checked) {
              this.$set(this.unSelectObj, item.bqitemid, true)
            } else {
              this.$delete(this.unSelectObj, item.bqitemid)
            }
          }
          this.$set(this.dataList, idx, Object.assign(item, {checked: !checked}))
          if (!checked) {
            this.$set(this.selectedObj, idx, item)
          } else {
            this.$delete(this.selectedObj, idx)
          }
          const selectList = []
          for (const key in this.selectedObj) {
            selectList.push(this.selectedObj[key].bqitemid)
          }
          // console.log(selectList)
          // console.log('==================')
          this.selectList = selectList
          break
        case 'fold': // 展开折叠
          const childShow = item.childShow
          this.$set(this.dataList, idx, Object.assign(item, {childShow: !childShow}))
          this.$set(this.dataList, idx + 1, Object.assign(this.dataList[idx + 1], {show: !childShow}))
          break
        case 'edit': // 修改
          if (item) {
            // console.log(Object.assign(item, {idx}))
            this.dialog.inventory.show = true
            this.dialog.inventory.data = Object.assign(item, {idx})
          }
          break
        case 'move': // 移动到
          let catalogIdGuid = ''
          if (item) {
            catalogIdGuid = item.bqcatalogIdGuid
          } else {
            this.dataList.forEach((tr) => {
              if (tr.bqitemid === this.selectList[0]) {
                catalogIdGuid = tr.bqcatalogIdGuid
              }
            })
          }
          if (catalogIdGuid) {
            service.inventory.getInventoryChapter({catalogIdGuid}).then((data) => {
              // console.log(data)
              if (+data.code === 200 && data.data) {
                // 请设置 移动到弹窗下拉框默认选中项 若不设置 默认选中select第一项
                this.dialog.moveTo.data = Object.assign(params, {
                  professionSelect: data.data.profession, // 当前所属的专业
                  chapterSelect: data.data.chapter // 当前所属的章节
                })
                this.dialog.moveTo.show = true
              }
            })
          }
          break
        default:
      }
    },
    // 6.1 确定导出
    exportConfirm (params) {
      let taskComplete = false
      const cacheKey = new Date().getTime()
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (+result.code === 200) {
            if (result.data !== undefined && result.data !== '') {
              let token = getCookie('ZJYTOKEN')
              service.inventory.download(result.data, token)
              // 操作记录
              this.addOperationRecords(2, params.num)
            }
          }
        }
      }
      service.inventory.export(Object.assign(params, {cacheKey})).then((data) => {
        // console.log(data)
        result = data
        afterTask()
      })
      // 获取进度条
      this.getProgress('export', 0, cacheKey).then(() => {
        taskComplete = true
        afterTask()
      })
    },
    // 6.2 确定删除
    deleteConfirm (params) {
      service.inventory.delete(params).then((data) => {
        // console.log(data)
        if (+data.code === 200) {
          !this.operationBatch && (this.$message.success('删除成功'))
          this.topButtonClick('refresh')
          // 录入操作记录
          this.addOperationRecords(1, params.num)
        } else {
          //  +data.code === 290004 无权限操作数据 操作失败时
          if (this.operationBatch) {
            this.topButtonClick('refresh')
          } else {
            this.$message.error(data.message || '删除成失败')
          }
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    // 6.3 修改清单 确定
    editSubmit (params) {
      const idx = params.idx
      this.dialog.inventory.show = false

      // 判断是否有数据更改
      let isChanged = true
      if (params.description === this.dataList[idx].description &&
          params.unit === this.dataList[idx].unit &&
          params.spec === this.dataList[idx].spec) {
        isChanged = false
      }
      if (!isChanged) {
        return
      }

      if (idx !== undefined && +idx > -1) {
        service.inventory.edit(Object.assign(params, {dbId: params.dbid, bqItemId: params.bqitemid})).then((data) => {
          // console.log(data)
          if (+data.code === 200) {
            this.$message.success('修改成功')
            // 录入操作记录
            this.addOperationRecords(3, 1)
            this.topButtonClick('refresh')
          } else {
            //  +data.code === 290004 无权限操作数据 操作失败时
            this.$message.error('修改失败')
          }
        }).catch((err) => {
          this.$message.error('修改失败')
          console.log(err)
        })
      }
    },
    // 6.3.1 修改清单 取消
    editCancel () {
      this.dialog.inventory.show = false
    },
    // 6.4 复制到电子档案室 确定
    copyConfirm (params) {
      let taskComplete = 0
      const modelType = '_bqItem'
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (+result.code === 200) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.dialog.copyResult.show = true
                let copyInfo = '复制总条数 '
                copyInfo += result.data.CopyCompanyDataErr + result.data.CopyCompanyDataOK
                copyInfo += ', 复制成功 '
                copyInfo += result.data.CopyCompanyDataOK
                copyInfo += '  条，复制失败  '
                copyInfo += result.data.CopyCompanyDataErr
                copyInfo += '  条'
                this.dialog.copyResult.text = copyInfo
                if (result.data.CopyCompanyDataErr > 0) {
                  this.dialog.copyResult.error = result.data.ErrDetail || []
                } else {
                  this.dialog.copyResult.error = null
                }
              }, 300)
            })
          }
          this.topButtonClick('refresh')
        }
      }
      service.inventory.copy(Object.assign(params, {modelType})).then(data => {
        // console.log(data)
        result = data
        afterTask()
      })
      // 获取进度条
      this.getProgress('copy', 1, modelType).then(({hit, res}) => {
        taskComplete = hit
        console.log(res)
        afterTask()
      })
    },
    // 6.5  移动到 确定
    moveToSubmit (params) {
      this.dialog.moveTo.show = false
      let taskComplete = 0
      const modelType = '_bqItem'
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          // taskComplete > 1 && +result.code === -1 异步任务 移动的接口返回{code: -1,message: 'timeout'} 如果进度条命中则代表成功
          if (+result.code === 200 || (taskComplete > 1 && +result.code === -1)) {
            // 录入操作记录
            this.addOperationRecords(4, params.num)
            !this.operationBatch && (this.$message.success('移动成功'))
          } else {
            !this.operationBatch && (this.$message.error(result.message || '移动失败'))
          }
          setTimeout(() => {
            this.topButtonClick('refresh')
          }, 500)
        }
      }
      service.inventory.move(Object.assign(params, {modelType})).then(res => {
        // console.log(res)
        console.log(window.moveProgressTimer)
        if (+res.code === 290004) {
          //  无权限操作数据 操作失败时
          if (window.moveProgressTimerEmitter){ clearTimeout(window.moveProgressTimerEmitter) }
          if (window.moveProgressTimer) {
            clearTimeout(window.moveProgressTimer) // 清除 轮询获取获取移动进度条的 计时器
          }
          this.$progress({closeAll: true}) // 关闭进度条弹窗
          if (this.operationBatch) {
            this.topButtonClick('refresh')
          } else {
            this.$message.error('操作失败')
          }
        } else {
          result = res
          afterTask()
        }
      })
      // 获取进度条
      this.getProgress('move', 0, modelType).then(({hit}) => {
        taskComplete = hit
        afterTask()
      })
    },
    // 6.5.1  移动到 取消
    moveToCancel () {
      this.dialog.moveTo.show = false
    },
    // 6.6 上传结果查看详情
    showDetail () {
      var win = window.open()
      // 流使用结束后 必须要关闭
      let htmlStr = ''
      this.dialog.copyResult.error.map(item => {
        htmlStr += `<tr>
            <td>${item.CopyCompanyDataCode}</td>
            <td>${item.CopyCompanyDataName}</td>
            <td>${item.CopyCompanyDataRepeat === true ? '重复' : ''}</td>
          </tr>`
      })
      win.document.write(`<head>
        <title>复制详情</title>
        <meta http-equiv="Content-Type" content="text/html;charset=utf-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge, chrome=1">
        <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">
        <style>
          *{margin:0;padding: 0;}
            .info{
              width: 1000px;
              margin: 20px auto;
            }
            table{
              border: 1px solid #ccc;
              border-collapse: collapse;
              border-spacing: 0;
              font-size: 14px;
            }
            caption{
              padding:8px 5px;
              border: 1px solid #ccc;
              border-bottom: none;
              text-align: left;
              font-size: 20px;
            }
            caption a{
              color: #2079FA;
              text-decoration: none;
              float: right;
            }
            tr{
              height: 30px;
            }
            tr:hover td{
              background-color: #E6F9FF;
            }
            th,
            td{
              padding:8px 5px;
              border: 1px solid #ccc;
              text-align: left;
            }
            th{
              background-color: #EEE;
              color: #666;
            }
          </style>
        </head>
        <body>
        <div class="info" id="___info">
          <table width="100%" cellspacing="0" cellpadding="0">
            <caption>复制详情<a href="javascript:window.print()">打印</a></caption>
            <thead>
              <tr>
                <th width="200">编码</th>
                <th>名称</th>
                <th>未导入原因</th>
              </tr>
            </thead>
            <tbody>
            ${htmlStr}
            </tbody>
          </table>
        </div>
        <body></head>`)
      win.document.close()
    },
    // 上传云文件
    UploadCloudFilesAffirm (vals, workspaceId) {
      // console.log(vals)
      let pathList = vals.map((item) => item.path)
      let params = {
        IsOffline: false,
        ImportType: 3,
        SourceType: 2,
        userType: this.user.userType
      }
      let parameter = {
        params,
        pathList: JSON.stringify(pathList),
        uploadType: 4,
        workspaceId
      }
      // this.uploadCloudFileParams = parameter
      console.log(this.uploadCloudFileParams)
      Bus.$emit('beforeUploadCloudFile', vals, parameter)
      // service.inventory.uploadCloudFile(parameter).then((res)=>{
      //   if(+res.code === 200){
      //   }
      // })
      // this.UploadCloudFilesShow = false
    },
    UploadCloudFilesCancle () {
      this.UploadCloudFilesShow = false
    }
    // 清单数据操作记录
    // recordsDataOpration(optType, num){
    //   let params = {
    //       account: this.user.userName,
    //       area: this.user.area,
    //       dataType: 1,
    //       optType: optType,
    //       num: num
    //     };
    //   let path = {
    //     workspaceId: getCookie('enterpriseWorkspaceIdValue')
    //   };
    //   this.recordsOpreation(1, [params], path);
    // }
  },
  components: {
    DialogSeniorSearch,
    OperationButtons,
    OperationSearch,
    OperationSelectMajor,
    SelectAll,
    Collapse,
    DialogMoveTo,
    SimpleTable,
    DialogEditInventory,
    UploadCloudFiles
  }
}
</script>
<style lang="less" type="text/less">
  @import "./index";
  .right-content .inventory_main {
    .table-wrapper .table-head-wrapper {
      margin-right: 0px;
    }
    .table-wrapper .table-body-wrapper {
      min-height: 100px;
      height: auto;

      tr {
        height: 46px;
      }
    }

    .page-box {
      position: fixed;
      bottom: 10px;
      /*width: calc(100% - 220px);*/
      /*width: calc(100% - 260px);*/
      /*min-width: 1100px;*/
      right: 10px;
    }
  }

  /*.checkbox-label{*/
  /*margin-left: 10px;*/
  /*&.th{*/
  /*margin-left: 7px;*/
  /*}*/
  /*}*/
  .view-more {
    cursor: pointer;
    display: inline-block;
    margin-top: 3px;
    width: 12px;
    height: 12px;
    background: transparent url("~@/assets/images/tree.png") 0 0 no-repeat
  }

  .close {
    background-position: 0 -54px;
  }

  .data1-p {
    line-height: 24px;
    padding-left: 105px;
    padding-right: 300px;
  }

  .shen-btn {
    cursor: pointer;
    color: #ff561a;

    &:hover {
      text-decoration: underline;
    }
  }

  .shen-ok {
    border-radius: 2px;
    padding: 0 3px 2px 3px;
    font-size: 12px;
    background-color: #ff561a;
    color: #fff !important;
  }

  .w__dialog--footer {
    border-top: none !important;
  }
</style>
